<script lang="ts">
  import * as Sidebar from "$lib/components/ui/sidebar/index.js";
</script>

<Sidebar.Inset>
  <header class="flex h-16 items-center gap-2 border-b border-border px-4">
    <Sidebar.Trigger class="md:hidden" />
    <h2 class="text-lg font-semibold">Dev info</h2>
  </header>
  <section class="p-6">
    <p class="text-sm text-muted-foreground">Developer information goes here.</p>
  </section>
</Sidebar.Inset>
